import { render } from "./FamilyIncomeBenefitPolicyDetails.vue?vue&type=template&id=d856d7ae&scoped=true"
import script from "./FamilyIncomeBenefitPolicyDetails.vue?vue&type=script&lang=js"
export * from "./FamilyIncomeBenefitPolicyDetails.vue?vue&type=script&lang=js"

import "./FamilyIncomeBenefitPolicyDetails.vue?vue&type=style&index=0&id=d856d7ae&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d856d7ae"]])

export default __exports__